/** @jsxImportSource @emotion/react */

import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, message } from "antd";
import { withdrawApi } from "api/withdraw";
import { WithdrawalSubMissionForm } from "api/withdraw/type";
import HelmetCustom from "components/common/HelmetCustom";
import InputCustom from "components/common/InputCustom";
import Loading from "components/common/Loading";
import Balance from "components/mobile/Balance";
import HeaderPage from "components/mobile/HeaderPage";
import { QueryKeys } from "constants/queryKeys";
import { useWithdrawContext } from "contexts/withdraw/withdraw.context";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import { useGetBalanceDV } from "api/user/query";
import BanksCollapse from "./BanksCollapse";
import { MWithdrawPageStyle } from "./index.style";
import WithdrawAttention from "./WithdrawAttention";

interface FormData {
  withdrawPoint: number;
}

const MWithdrawPage = () => {
    const { state } = useWithdrawContext();
  const [messageApi, contextHolder] = message.useMessage();

  const { data: username } = useQuery<string>([QueryKeys.username]);

  const { data: dataWithdrawSetting, isLoading: isWithdrawSettingLoading } =
    useQuery({
      queryKey: [QueryKeys.WithdrawForm],
      queryFn: () => withdrawApi.getWithdrawalForm(username as string),
      enabled: !!username,
    });
  const { refetch: refetchBalance } = useGetBalanceDV()

  const schema = yup
    .object({
      withdrawPoint: yup
        .number()
        // .min(dataWithdrawSetting?.setting.min_withdrawal || 0)
        // .max(dataWithdrawSetting?.setting.max_withdrawal || 0)
        .required(),
    })
    .required();

  const {
    control,
    handleSubmit,
    watch,
    reset,
    // setValue,
    clearErrors,
    formState: {
      // errors,
      isValid,
    },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
    mode: "all",
  });

  const withdrawPoint = Number(watch("withdrawPoint") || 0);
  const twdCurrency = dataWithdrawSetting?.currencies.find(
    (currency) => currency.currency_id === "3",
  );
  const twdWithdrawRate = Number(twdCurrency?.w_currency_rate || 0);
  const isTwdBankSelected = state.playerBankSelected?.currency_id === "3";
  const usdtConvertedAmount =
    twdWithdrawRate > 0 ? withdrawPoint / twdWithdrawRate : 0;

  const { mutate, isLoading } = useMutation({
    mutationKey: [QueryKeys.WithdrawSubmission],
    mutationFn: (payload: WithdrawalSubMissionForm) =>
      withdrawApi.withdrawalSubmission(payload.username, payload),
    onSuccess(data) {
      messageApi.open({
        type: "success",
        content: data.msg,
      });
      reset({
        withdrawPoint: undefined,
      });
      clearErrors();
      refetchBalance();
    },
    onError(error: any) {
      messageApi.open({
        type: "error",
        content: error.message,
      });
    },
  });

  const onSubmit = (form: FormData) => {
    if (
      !dataWithdrawSetting?.player_bank.length &&
      !state.playerBankSelected?.player_bank_id
    ) {
      messageApi.open({
        type: "error",
        content: "請新增銀行帳戶",
      });
      return;
    }

    const payload: WithdrawalSubMissionForm = {
      username: username || "",
      currency_id: dataWithdrawSetting?.currencies[0].currency_id || "",
      player_bank_id: state.playerBankSelected?.player_bank_id || "",
      amount: form.withdrawPoint,
    };
    mutate(payload);
  };

  return (
    <div css={MWithdrawPageStyle.self}>
      <HeaderPage
        title={"提款區"}
        rightComponent={<Balance />}
      />
      <HelmetCustom title={"提款區"} />
      {isWithdrawSettingLoading ? (
        <Loading height={500} center />
      ) : (
        <>
          <div css={MWithdrawPageStyle.bankTitle}>{"銀行"}</div>
          <form
            css={MWithdrawPageStyle.formWrapper}
            onSubmit={handleSubmit(onSubmit)}
          >
            <BanksCollapse />
            <div css={MWithdrawPageStyle.formGroup}>
              <label>{"提款點數"}</label>
              {/* <Tooltip
                overlayInnerStyle={{ padding: "8px" }}
                title={
                  <div css={MWithdrawPageStyle.tooltipDesc}>
                    <img loading="lazy" src={IconPrompt} alt="" />
                    <span style={{ color: "red" }}>
                      {`${t("withdrawal.point")} ${
                        dataWithdrawSetting?.setting.min_withdrawal || 0
                      } ~ ${dataWithdrawSetting?.setting.max_withdrawal || 0}`}
                    </span>
                  </div>
                }
                color="#fff"
                open={!!errors.withdrawPoint && !!watch("withdrawPoint")}
                placement="bottomLeft"
              > */}
              <InputCustom
                id="withdrawPoint"
                type="number"
                control={control}
                name="withdrawPoint"
                placeholder={`0.00`}
                disabled={isLoading}
              />
              {/* </Tooltip> */}
            </div>
            {isTwdBankSelected && twdWithdrawRate > 0 ? (
              <div
                css={[
                  MWithdrawPageStyle.valueFormat,
                  MWithdrawPageStyle.actualValue,
                ]}
              >
                <div>{"實際"}</div>
                <div>
                  <span className="amount">
                    <span className="value">
                      {usdtConvertedAmount.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                    <span>USDT</span>
                  </span>
                </div>
              </div>
            ) : null}

            <div css={MWithdrawPageStyle.formSubmit}>
              <Button
                type="primary"
                htmlType="submit"
                block
                disabled={!isValid}
                loading={isLoading}
              >
                {"確認"}
              </Button>
            </div>
          </form>
          <WithdrawAttention />
        </>
      )}
      {contextHolder}
    </div>
  );
};

export default MWithdrawPage;
